import { Icon } from '@genial/components';
import { ColorTypes } from '@genial/design-tokens';
import { IconographyTypes } from '@genial/icons';
import React from 'react';

export interface CustomerDuckRightIconProps {
  type: 'success' | 'warning' | 'error' | 'blocked';
}

export const CustomerDuckRightIcon: React.FC<CustomerDuckRightIconProps> = ({ type }) => {
  const getValueIconProps = (): {
    name: IconographyTypes.Option;
    color: ColorTypes.Option;
  } => {
    switch (type) {
      case 'success':
        return { name: 'Success', color: 'feedback.success.default' };
      case 'warning':
        return { name: 'Warning', color: 'feedback.attention.default' };
      case 'error':
        return { name: 'Error', color: 'feedback.error.default' };
      case 'blocked':
        return { name: 'Cancel', color: 'neutral.light' };
    }
  };

  return <Icon {...getValueIconProps()} size="xxxs" />;
};
